import type { RouteRecordRaw } from 'vue-router';

export const accountsRoutes = [
  {
    path: 'accounts',
    name: 'accounts',
    component: () => import('./pages/AccountsPage.vue'),
    meta: { title: 'Accounts' },
  },
  {
    path: 'accounts/:accountId/review',
    name: 'account-review',
    component: () => import('./pages/AccountReviewPage.vue'),
    meta: { title: 'Account review' },
  },
  {
    path: 'accounts/open',
    name: 'open-account',
    component: () => import('./pages/OpenAccountPage.vue'),
    meta: { title: 'Open New Account' },
  },
  {
    path: 'ibans',
    redirect: { name: 'accounts' },
  },
  {
    path: 'ibans/open',
    redirect: { name: 'open-account' },
  },
  {
    path: 'ibans/:accountId/review',
    redirect: (to) => ({ name: 'account-review', params: to.params }),
  },
] as const satisfies readonly RouteRecordRaw[];
